<template lang="pug">
v-container.py-6.d-flex.flex-column.align-center.px-0.page-home-covid(
  v-if="content.img"
)
  grid-container.align-center(
    cols="100%",
    cols-sm="400px auto",
    cols-md="400px 340px",
    gap-md="80px",
    rows-md="420px"
  )
    .page-home-covid-picture.mt-4
      img(:src="files + content.img")
      .page-home-covid-circle
    .px-4.px-md-0
      .text-h4.font-weight-bold.primary--text(v-html="title")
      v-btn.font-weight-bold.text-none.px-8.mt-4(
        :to="path",
        color="primary",
        depressed
      ) Ver todos
</template>

<script>
const _config = {
  title: "BOLETIM<br>CORONAVIRUS",
  mod: "covid",
  path: "/boletim-coronavirus",
};

export default {
  data: () => ({
    title: _config.title,
    path: _config.path,
  }),
  computed: {
    content() {
      const content = this.$rest(_config.mod).list[
        this.$rest(_config.mod).list.length - 1
      ];

      return content || {};
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get();
  },
};
</script>

<style>
.page-home-covid-picture {
  position: relative;
  width: 100%;
  height: 100%;
}
.page-home-covid-picture img {
  position: absolute;
  left: -35px;
  bottom: -5px;
  width: 90%;
  height: 90%;
  z-index: 9;
  object-fit: contain;
}
.page-home-covid-circle {
  position: absolute;
  left: -149px;
  bottom: -158px;
  height: 144%;
  width: 150%;
  clip-path: circle(50%);
  background: var(--v-primary-base);
}
@media screen and (max-width: 960px) {
  .page-home-covid-circle {
    left: -180px;
    bottom: -155px;
    height: 150%;
    width: 150%;
  }
  .page-home-covid-picture {
    height: 400px;
  }
  .page-home-covid-picture img {
    width: 85%;
    max-height: 100%;
    left: -1px;
    bottom: -6px;
  }
}

@media screen and (max-width: 600px) {
  .page-home-covid .grid-container {
    width: 100%;
    justify-content: center;
  }
  .page-home-covid-picture {
    width: 100%;
  }
  .page-home-covid-circle {
    left: 0;
    bottom: -120px;
    height: 143%;
    width: 100%;
  }
  .page-home-covid-picture img {
    width: 100%;
    max-height: 100%;
    left: 0px;
    bottom: 0px;
  }
  .page-home-covid-picture {
    grid-row-start: 2;
  }
}
</style>
